<template>
  <section>
    <news-list :query="query" />
  </section>
</template>

<script>
import NewsList from '@/components/company/NewsList'

export default {
  name: 'News',
  components: {
    NewsList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
